<template>
  <v-container fluid>
    <!-- <v-container fluid> -->
    <v-row>
      <global-EventFilterMenu
        header="Transaction Filter"
        showStallholders
        showTerminals
        headerButtonText="Show additional filters"
        :showTransactionFilters="showTransactionFilters"
        :headerButtonAction="toggleFilters"
      />
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-file-table </v-icon>
            Transactions
            <v-spacer />
            <v-btn small class="mr-1" @click="generateCSV">
              Generate CSV Report
            </v-btn>
            <v-btn small @click="createPDF"> Generate tax invoice </v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <!-- TABLE -->
            <!-- <tables-simple
              :tableHeadings="topStalls.headings"
              :tableDataProperties="topStalls.dataProperties"
              :tableData="topStalls.data"
              :ranks="true"
            /> -->

            <v-data-table
              v-model="selectedTransaction"
              :headers="headers"
              :items="formattedTransactions"
              item-key="TransactionID"
              show-select
              class="elevation-5"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import "izitoast/dist/css/iziToast.min.css"; // loading css
import iziToast from "izitoast/dist/js/iziToast.min.js"; // you have access to iziToast now

export default {
  data: () => ({
    showFilters: false,
    selectedTransaction: [],
    dummyTransactions: [
      {
        Amount: 125.5,
        CardDiscountSurchargeTotal: 2.5,
        EventId: "EVT001",
        EventName: "Summer Food Festival 2024",
        Items: 3,
        OrderNumber: "ORD12345",
        ProductDiscountSurchargeTotal: 0,
        StallHolderId: "SH001",
        StallHolderName: "John's Coffee",
        StallName: "Coffee Corner",
        StallUserName: "johncoffee",
        Stan: "123456",
        Status: "Completed",
        DeviceId: "DEV001",
        TerminalID: "TERM001",
        TerminalNumber: "T1",
        TimeCreated: "2024-03-15 14:30:00",
        TransactionID: "TRX001",
        Type: "Sale",
      },
      {
        Amount: 89.99,
        CardDiscountSurchargeTotal: 1.8,
        EventId: "EVT001",
        EventName: "Summer Food Festival 2024",
        Items: 2,
        OrderNumber: "ORD12346",
        ProductDiscountSurchargeTotal: 5.0,
        StallHolderId: "SH002",
        StallHolderName: "Pizza Paradise",
        StallName: "Pizza Corner",
        StallUserName: "pizzapara",
        Stan: "123457",
        Status: "Completed",
        DeviceId: "DEV002",
        TerminalID: "TERM002",
        TerminalNumber: "T2",
        TimeCreated: "2024-03-15 15:45:00",
        TransactionID: "TRX002",
        Type: "Sale",
      },
      {
        Amount: 45.0,
        CardDiscountSurchargeTotal: 0.9,
        EventId: "EVT001",
        EventName: "Summer Food Festival 2024",
        Items: 1,
        OrderNumber: "ORD12347",
        ProductDiscountSurchargeTotal: 0,
        StallHolderId: "SH003",
        StallHolderName: "Ice Cream Delight",
        StallName: "Sweet Treats",
        StallUserName: "icecream",
        Stan: "123458",
        Status: "Refunded",
        DeviceId: "DEV003",
        TerminalID: "TERM003",
        TerminalNumber: "T3",
        TimeCreated: "2024-03-15 16:20:00",
        TransactionID: "TRX003",
        Type: "Refund",
      },
    ],
    headers: [
      { text: "Amount", value: "Amount" },
      {
        text: "CardDiscountSurchargeTotal",
        value: "CardDiscountSurchargeTotal",
      },
      { text: "EventId", value: "EventId" },
      { text: "EventName", value: "EventName" },
      { text: "Items", value: "Items" },
      { text: "OrderNumber", value: "OrderNumber" },
      {
        text: "ProductDiscountSurchargeTotal",
        value: "ProductDiscountSurchargeTotal",
      },
      { text: "StallHolderId", value: "StallHolderId" },
      { text: "StallHolderName", value: "StallHolderName" },
      { text: "StallName", value: "StallName" },
      { text: "StallUserName", value: "StallUserName" },
      { text: "Stan", value: "Stan" },
      { text: "Status", value: "Status" },
      { text: "DeviceId", value: "DeviceId" },
      { text: "TerminalID", value: "TerminalID" },
      { text: "TerminalNumber", value: "TerminalNumber" },
      { text: "TimeCreated", value: "TimeCreated" },
      { text: "TransactionID", value: "TransactionID" },
      { text: "Type", value: "Type" },
    ],
  }),
  created() {
    this.getTransactions();
    console.log(this.transactionsTransactions);
  },
  filters: {
    currency(value) {
      var formatter = new Intl.NumberFormat("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return "$" + formatter.format(value);
    },
    number(value) {
      var formatter = new Intl.NumberFormat("en-AU", {
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
  computed: {
    ...mapState("filter", [
      "globalEventFilter",
      "globalYearFilter",
      "deviceId",
      "stan",
      "totalAmount",
    ]),
    ...mapState("dashboard", ["transactionsTransactions"]),
    ...mapState("app", ["showTransactionFilters"]),
    formattedTransactions() {
      if (!this.transactionsTransactions) return [];
      return [];
      // return this.transactionsTransactions.map(transaction => ({
      // return this.dummyTransactions
      //   .filter(transaction => {
      //     // Filter by deviceId if set - partial match
      //     if (this.deviceId && !transaction.DeviceId.toLowerCase().includes(this.deviceId.toLowerCase())) {
      //       return false;
      //     }
      //     // Filter by stan if set - partial match
      //     if (this.stan && !transaction.Stan.toLowerCase().includes(this.stan.toLowerCase())) {
      //       return false;
      //     }
      //     // Filter by totalAmount if set - convert to string and partial match
      //     if (this.totalAmount) {
      //       const amountStr = transaction.Amount.toString().toLowerCase();
      //       const searchAmount = this.totalAmount.toString().toLowerCase();
      //       if (!amountStr.includes(searchAmount)) {
      //         return false;
      //       }
      //     }
      //     return true;
      //   })
      //   .map(transaction => ({
      //     ...transaction,
      //     Amount: transaction.Amount !== undefined ? this.$options.filters.currency(transaction.Amount) : 'N/A',
      //     Items: transaction.Items !== undefined ? this.$options.filters.number(transaction.Items) : 'N/A'
      //   }));
    },
  },
  // watch: {

  // },
  methods: {
    ...mapActions("dashboard", ["getTransactions"]),
    ...mapMutations("app", ["setShowTransactionFilters"]),
    toggleFilters() {
      this.setShowTransactionFilters(!this.showTransactionFilters);
    },
    createPDF() {
      if (!this.selectedTransaction.length) {
        iziToast.warning({
          title: "Warning",
          message: "Please select at least one transaction",
          position: "topRight",
        });
        return;
      }

      // console.log(this.globalEventFilter)

      this.$pdfEditor.createPdf(
        `INVOICE-${this.selectedTransaction[0].TransactionID}`,
        this.selectedTransaction
      );
    },
    generateCSV() {
      if (!this.selectedTransaction.length) {
        iziToast.warning({
          title: "Warning",
          message: "Please select at least one transaction",
          position: "topRight",
        });
        return;
      }

      // Get headers from the table
      const headers = this.headers.map((header) => header.text);

      // Create CSV content
      const csvContent = [
        headers.join(","), // Header row
        ...this.selectedTransaction.map((transaction) => {
          return this.headers
            .map((header) => {
              const value = transaction[header.value];
              // Handle values that might contain commas by wrapping in quotes
              return typeof value === "string" && value.includes(",")
                ? `"${value}"`
                : value;
            })
            .join(",");
        }),
      ].join("\n");

      // Create blob and download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `${this.globalEventFilter.EventName}-transactions.csv`
      );
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
